import { NgModule } from '@angular/core';
import { IconActionComponent } from './action-icon.component';
import { CommonModule } from '@angular/common';
// import { MatMenuModule } from '@angular/material';
import { MatMenuModule } from '@angular/material/menu';
import { MatButtonModule } from '@angular/material/button';
import { DomHandler } from '../../../primeNg/dom/domhandler';


@NgModule({
    imports: [
        CommonModule,
        MatMenuModule,
        MatButtonModule

    ],
    providers: [
        DomHandler
    ],
    declarations: [
        IconActionComponent
    ],
    exports: [
        IconActionComponent
    ]
})
export class IconActionModule { } 
